"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshToken = refreshToken;
exports.getRefreshTokenReq = void 0;

var _apolloBoost = require("apollo-boost");

var authLocalStore = _interopRequireWildcard(require("../authLocalStore"));

var credentials = _interopRequireWildcard(require("../credentials"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var REFRESH_TOKEN_QUERY = (0, _apolloBoost.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query {\n    refreshToken {\n      auth\n      token\n      user {\n        firstName\n        lastName\n        userId\n        email\n        imageUrl\n        email\n        preferences\n        isAvailable\n        initialSetup\n      }\n    }\n  }\n"])));
/* istanbul ignore next */

var getRefreshTokenReq = function getRefreshTokenReq() {
  return {
    query: REFRESH_TOKEN_QUERY,
    module: 'users',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      return {};
    }
  };
};

exports.getRefreshTokenReq = getRefreshTokenReq;

function refreshToken(_x) {
  return _refreshToken.apply(this, arguments);
}

function _refreshToken() {
  _refreshToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(refreshTokenReq) {
    var _credentials$get, _credentials$get$orig, original, _credentials$get$orig2, origURL, ghost, result, refreshTokenData, resultWithOriginal;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _credentials$get = credentials.get(), _credentials$get$orig = _credentials$get.original, original = _credentials$get$orig === void 0 ? null : _credentials$get$orig, _credentials$get$orig2 = _credentials$get.origURL, origURL = _credentials$get$orig2 === void 0 ? null : _credentials$get$orig2, ghost = _credentials$get.ghost;
            _context.prev = 1;
            _context.next = 4;
            return refreshTokenReq();

          case 4:
            result = _context.sent;

            if (!(result.error || result.data.refreshToken && result.data.refreshToken.auth === false)) {
              _context.next = 8;
              break;
            }

            // Clear credentials if refresh of token didn't succeed,
            // user should log in again
            credentials.clear();
            return _context.abrupt("return");

          case 8:
            refreshTokenData = result.data.refreshToken;
            resultWithOriginal = {
              data: {
                refreshToken: _objectSpread(_objectSpread({}, refreshTokenData), {}, {
                  original: original,
                  origURL: origURL,
                  ghost: ghost
                })
              }
            };
            authLocalStore.save(resultWithOriginal);
            _context.next = 15;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));
  return _refreshToken.apply(this, arguments);
}